import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APISpecificationsService } from '@core/api/generated';

/** Redirects API detail pages to the API overview when the specification is absent. */
export const apiSpecificationExistsGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const apiSpecificationsService = inject(APISpecificationsService);
  const projectId = route.paramMap.get('projectId');
  const branchName = route.queryParamMap.get('branchName');
  const specificationPath = route.queryParamMap.get('specificationPath');

  if (!projectId || !branchName || !specificationPath) return true;

  return apiSpecificationsService
    .getApiSpecification(projectId, branchName, specificationPath)
    .pipe(
      map(() => true),
      catchError(() =>
        of(router.createUrlTree(['/projects', projectId, 'api'], { queryParams: { branchName } }))
      )
    );
};
